export const safeGetItem = key => {
  let valueFromStorage;
  try {
    valueFromStorage = localStorage.getItem(key);
  } catch (e) {
    console.error(`Error reading from localStorage`, e);
  }
  return valueFromStorage;
};
export const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.error(`Error saving to localStorage`, e);
  }
};
export const getOnboardingDisabledInSelenium = () => safeGetItem('selenium.disable.onboarding_tours') === 'true';